import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="flex min-h-[70vh] items-center justify-center px-4 pt-16 md:pt-20">
        <div className="text-center">
          <p className="font-heading text-7xl font-black text-primary-100 select-none md:text-9xl">
            404
          </p>
          <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            页面走丢了
          </h1>
          <p className="mt-3 max-w-md text-sm text-foreground-600">
            你要找的页面不存在或已被移除，不妨回到首页继续探索仙侠世界。
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-home-4-line"></i>
              回到首页
            </Link>
            <Link
              to="/category"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-400"
            >
              <i className="ri-layout-grid-line"></i>
              浏览剧集
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}